import { useMutation } from "@tanstack/react-query";
import { buyerRequestsMutationApi } from "@/shared/api/buyer-requests/mutation";
import useAppToasts from "@/features/line-sheet-sets/hooks/use-app-toasts";

const usePostBrandRequest = (brandName: string) => {
  const { info } = useAppToasts({ id: "GLOBAL" });

  const { mutate: postBrandRequest } = useMutation({
    mutationKey: ["brand-request", brandName],
    // buyerId = 바이어 회사 id (identity.company.id). 유저 id(identity.id)가 아니다.
    mutationFn: (buyerId: number) =>
      buyerRequestsMutationApi.addBrand(buyerId, {
        brand_name: brandName,
      }),
    onSuccess: () => {
      info("요청 사항이 제출되었습니다.");
    },
  });
  return {
    postBrandRequest,
  };
};

export default usePostBrandRequest;
